<script>
import {fetchAndParseFeed} from "@/utils/rss";
import moment from "moment";

export default {
  name: "NewsPreview",
  computed: {
    moment() {
      return moment
    }
  },
  data() {
    return {
      newsItem: null,
    }
  },
  mounted() {
    const isDev = process.env.NODE_ENV === 'development';
    const localPath = (process.env.BASE_URL || '/') + 'sample-einblicke.xml';
    const feedUrl = isDev ? localPath : 'https://www.amz-steuer.de/share/einblicke.xml';
    fetchAndParseFeed(feedUrl)
        .then(data => {
          this.newsItem = data.items[0];
          console.log('Parsed feed:', this.newsItem);
        })
        .catch(err => console.error('Feed fetch/parse error:', err));
  }
}
</script>

<template>
<v-card v-if="newsItem">
  <v-img :src="newsItem.media[0].url" alt="News Image" class="mb-4" max-height="300"/>
  <v-card-title class="text-break">{{ newsItem.title }}</v-card-title>
  <v-card-subtitle>{{ moment(newsItem.pubDate).format("DD.MM.YYYY") }}</v-card-subtitle>
  <v-card-text v-html="newsItem.description"></v-card-text>
  <v-card-actions>
    <v-btn
        color="primary"
        text
        @click="">
      Weiterlesen
    </v-btn>
  </v-card-actions>
</v-card>
</template>

<style scoped>

</style>